import { motion, useScroll, useTransform } from "framer-motion";

export const CarWatermark = ({ className = "", flip = false, tone = "white" }) => {
  const { scrollYProgress } = useScroll();
  const x = useTransform(scrollYProgress, [0, 1], flip ? [70, -70] : [-70, 70]);
  const stroke = tone === "red" ? "rgba(237,28,36,0.07)" : "rgba(255,255,255,0.05)";

  return (
    <motion.div
      aria-hidden="true"
      style={{ x }}
      className={`pointer-events-none absolute select-none ${className}`}
    >
      <svg viewBox="0 0 136 64" fill="none" className="h-auto w-full">
        <path
          d="M14 44 L14 34 L24 32 L37 20 L42 18 L80 18 L95 30 L116 33 L122 36 L122 44"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinejoin="miter"
        />
        <circle cx="42" cy="44" r="5" stroke={stroke} strokeWidth="1.5" />
        <circle cx="98" cy="44" r="5" stroke={stroke} strokeWidth="1.5" />
      </svg>
    </motion.div>
  );
};
